export var BANNER = {
  bgColor: {
    "private": '--_nva-banner--bg-color',
    "public": '--nva-banner--bg-color',
    value: 'hsl(var(--g-color-error))'
  },
  fgColor: {
    "private": '--_nva-banner--fg-color',
    "public": '--nva-banner--fg-color',
    value: 'hsl(var(--g-color-error-contrast))'
  },
  dividerColor: {
    "private": '--_nva-banner--divider-color',
    "public": '--nva-banner--divider-color',
    value: 'hsl(var(--g-color-white) / 0.2)'
  },
  height: {
    "public": '--nva-banner--height'
  },
  topContentHeight: {
    "private": '--_nva-banner--top-content-height',
    "public": '--nva-banner--top-content-height',
    value: "calc(\n\t\t\t(var(--g-line-height-h6)) * var(--g-font-size-h6)\n\t\t\t+\n\t\t\t((var(--g-line-height-body2)) * var(--g-font-size-body2) * 2)\n\t\t\t+\n\t\t\tvar(--g-spacing-2)\n\t\t)"
  }
};